const $ = jQuery;
const parseParams = (querystring) => {

    // parse query string
    const params = new URLSearchParams(querystring);

    const obj = {};

    // iterate over all keys
    for (const key of params.keys()) {
        if (params.getAll(key).length > 1) {
            obj[key] = params.getAll(key);
        } else {
            obj[key] = params.get(key);
        }
    }

    return obj;
};

$(function () {

    $('.tags a').on('click', function (e) {
        e.preventDefault();
        document.location = '/?filter=' + $(this).text();
        return false;
    });
    $('.js-content-category-link').on('click', function (e) {
        e.preventDefault();
        document.location = '/?filter=' + $(this).data('slug');
        return false;
    });
    const params = parseParams(window.location.search);

    $(document).on('click', '.home .post-category-info a', function (e) {
        e.preventDefault();
        console.log($(this).data('slug'));
        $('.cat-list_item').filter(`[data-slug="${$(this).data('slug')}"]`).trigger('click');
        return false;
    });
    if ('filter' in params) {

        setTimeout(function () {
            const $el = $('.cat-list_item').filter(`[data-slug="${params.filter}"]`);
            const h = $('.site-header').height();
            $('html, body').stop().animate({ scrollTop: $('.js-scroll-to-target').offset().top - h }, 500, 'swing', function () {
                $el.trigger('click');
            });
        }, 500);

    }

    $(".js-return__button").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 300);
    });

    $(window).on('load', function () {
        var frameName = new ds07o6pcmkorn({
            openElementId: "#shielded-logo",
            modalID: "modal",
        });
        frameName.init();
    });
});